import Vue from 'vue'
import { MutationTree } from 'vuex/types/index'

import { RequestParameters } from '~/utils/SohoApi/SohoApi'
import { extractResourceIds, filterId } from '~/utils/store'

import { PerksState, PerksFilter, Perk, PerkResource } from './perks.types'

interface PerksMutation {
  params: RequestParameters<Perk, PerksFilter>
  data: Perk[]
}

const mutations: MutationTree<PerksState> = {
  SET_PERK (state, perk: PerkResource) {
    const { id } = perk

    Vue.set(state.data, id, perk)
  },

  SET_PERKS (state, { params, data }: PerksMutation) {
    if (data && data.length <= 0) {
      return
    }

    data.forEach(perk => Vue.set(state.data, perk.id, perk))

    const id = filterId(params)

    Vue.set(state.filters, id, extractResourceIds(data))
  }
}


export default mutations
